import { createContext, useContext, useMemo } from "react";
import type { ReactNode } from "react";

import type { ApiClient } from "@markeroo/shared";

import { HttpApiClient } from "../api/client";
import { API_BASE_URL } from "../api/config";
import { useAuthStore } from "../stores/auth";

export const ApiClientContext = createContext<ApiClient | null>(null);

// Fallback client for contexts rendered outside ApiClientProvider (e.g. public share pages, tests)
let fallbackClient: ApiClient | null = null;

export function ApiClientProvider({ children }: { children: ReactNode }) {
  const client = useMemo(
    () => new HttpApiClient({
      baseURL: API_BASE_URL,
      tokenProvider: () => useAuthStore.getState().accessToken
    }),
    []
  );

  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
}

export function useApiClient(): ApiClient {
  const context = useContext(ApiClientContext);
  if (context) {
    return context;
  }

  if (!fallbackClient) {
    fallbackClient = new HttpApiClient({ baseURL: API_BASE_URL, tokenProvider: () => null });
  }

  return fallbackClient;
}
